export function EmptyKnockoutStage() {
  return (
    <div className="flex flex-col items-center justify-center py-8 text-center">
      <div className="rounded-full bg-gray-100 p-4">
        <svg
          className="h-12 w-12 text-gray-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
          />
        </svg>
      </div>
      <h3 className="mt-4 text-lg font-medium">
        Fase de eliminación no disponible
      </h3>
      <p className="mt-2 text-sm text-gray-500">
        La fase de eliminación directa aún no ha comenzado o no hay datos
        disponibles.
      </p>
      <p className="mt-1 text-sm text-gray-500">
        Primero debes completar todos los partidos de la fase de grupos y
        generar la fase de eliminatorias.
      </p>
    </div>
  );
}
